 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		67: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		67: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "chunks/" + ({"0":"common","1":"CheckoutPage","2":"DoctorPortalComponent~SearchPage","3":"trumbowyg-plugins-trumbowyg-cleanpaste","4":"trumbowyg-plugins-trumbowyg-fontfamily","5":"trumbowyg-plugins-trumbowyg-fontsize","6":"trumbowyg-plugins-trumbowyg-image","7":"trumbowyg-plugins-trumbowyg-lineheight","8":"trumbowyg-plugins-trumbowyg-moveText","9":"trumbowyg-plugins-trumbowyg-quote","10":"trumbowyg-plugins-trumbowyg-replaceEmptyHrefLinks","11":"vendors~DoctorPortalComponent~SearchPage","13":"AccessDenied","14":"AppointmentViewerPage","15":"AppointmentsPage","16":"AuthLinks","17":"BillsPage","18":"CallSound","19":"ChangeEmailConfirmation","20":"ChatsPage","21":"ConfirmPage","22":"ConfirmationPage","23":"ConsentFormSwitcher","24":"ContactSupportPage","25":"DashboardPage","26":"DoctorListPage","27":"DoctorPortalComponent","28":"DocumentsPage","29":"DrivingLicense","30":"EmailLogs","31":"EmailTemplatesPage","32":"ErrorPage","33":"ExpiredLink","34":"HeaderFilters","35":"Home","36":"Inquiries","37":"InstructionsPage","38":"InvitesPage","39":"LoginPage","40":"MarketingEmailsPage","41":"NotificationsPage","42":"Ordering","43":"OrdersPage","44":"PageEditorPage","45":"PagesPage","46":"PortalFromBBY","47":"PrivacyPolicy","48":"ProcedurePage","49":"Procedures","50":"Product","51":"QuickPayPage","52":"RecoverPage","53":"RegisterPage","54":"SearchPage","55":"ShoppingCart","56":"ShortLinks","57":"SmsLogs","58":"Special","59":"Specials","60":"Specialties","61":"Specialty","62":"ThemeSwitch","63":"UserSessions","64":"Users","65":"app-components-Layouts-DashboardLayout-DashboardLayout","66":"common-react-components-Forms-Wysiwyg-Wysiwyg","68":"trumbowyg","69":"trumbowyg-plugins","70":"trumbowyg-ru","71":"vendors~ConsentFormSwitcher","72":"vendors~DoctorPortalComponent","73":"vendors~DocumentsPage","74":"vendors~HeaderFilters","75":"vendors~MarketingEmailsPage","76":"vendors~Product","77":"vendors~RegisterPage","78":"vendors~Specials","79":"vendors~app-components-Layouts-DashboardLayout-DashboardLayout","80":"vendors~jquery","81":"vendors~signalR","82":"vendors~trumbowyg"}[chunkId]||chunkId) + ".chunk." + "bf5e659a14e450bb6183" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"13":1,"20":1,"22":1,"23":1,"24":1,"26":1,"27":1,"35":1,"37":1,"38":1,"42":1,"43":1,"46":1,"47":1,"50":1,"51":1,"52":1,"53":1,"54":1,"58":1,"59":1,"61":1,"62":1,"65":1,"66":1,"74":1,"77":1,"78":1,"79":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "styles/" + ({"0":"common","1":"CheckoutPage","2":"DoctorPortalComponent~SearchPage","3":"trumbowyg-plugins-trumbowyg-cleanpaste","4":"trumbowyg-plugins-trumbowyg-fontfamily","5":"trumbowyg-plugins-trumbowyg-fontsize","6":"trumbowyg-plugins-trumbowyg-image","7":"trumbowyg-plugins-trumbowyg-lineheight","8":"trumbowyg-plugins-trumbowyg-moveText","9":"trumbowyg-plugins-trumbowyg-quote","10":"trumbowyg-plugins-trumbowyg-replaceEmptyHrefLinks","11":"vendors~DoctorPortalComponent~SearchPage","13":"AccessDenied","14":"AppointmentViewerPage","15":"AppointmentsPage","16":"AuthLinks","17":"BillsPage","18":"CallSound","19":"ChangeEmailConfirmation","20":"ChatsPage","21":"ConfirmPage","22":"ConfirmationPage","23":"ConsentFormSwitcher","24":"ContactSupportPage","25":"DashboardPage","26":"DoctorListPage","27":"DoctorPortalComponent","28":"DocumentsPage","29":"DrivingLicense","30":"EmailLogs","31":"EmailTemplatesPage","32":"ErrorPage","33":"ExpiredLink","34":"HeaderFilters","35":"Home","36":"Inquiries","37":"InstructionsPage","38":"InvitesPage","39":"LoginPage","40":"MarketingEmailsPage","41":"NotificationsPage","42":"Ordering","43":"OrdersPage","44":"PageEditorPage","45":"PagesPage","46":"PortalFromBBY","47":"PrivacyPolicy","48":"ProcedurePage","49":"Procedures","50":"Product","51":"QuickPayPage","52":"RecoverPage","53":"RegisterPage","54":"SearchPage","55":"ShoppingCart","56":"ShortLinks","57":"SmsLogs","58":"Special","59":"Specials","60":"Specialties","61":"Specialty","62":"ThemeSwitch","63":"UserSessions","64":"Users","65":"app-components-Layouts-DashboardLayout-DashboardLayout","66":"common-react-components-Forms-Wysiwyg-Wysiwyg","68":"trumbowyg","69":"trumbowyg-plugins","70":"trumbowyg-ru","71":"vendors~ConsentFormSwitcher","72":"vendors~DoctorPortalComponent","73":"vendors~DocumentsPage","74":"vendors~HeaderFilters","75":"vendors~MarketingEmailsPage","76":"vendors~Product","77":"vendors~RegisterPage","78":"vendors~Specials","79":"vendors~app-components-Layouts-DashboardLayout-DashboardLayout","80":"vendors~jquery","81":"vendors~signalR","82":"vendors~trumbowyg"}[chunkId]||chunkId) + "." + "bf5e659a14e450bb6183" + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 270);
